import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TestInternalEmailSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof TestInternalEmailSchema>>

export function useTestInternalEmailMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestInternalEmailSchema>) => {
      const response = await axios.post<Response>(`/campaigns/test-internal-email`, data)

      return response.data.data
    },
  })
}
